(() => {
  'use strict';
  const template = document.getElementById('sac-cart-recovery-template');
  if (!(template instanceof HTMLTemplateElement) || template.dataset.bound === 'true') return;
  template.dataset.bound = 'true';
  const footerSelector = '.upcart-footer';
  const cardSelector = '[data-sac-cart-recovery="upcart"]';
  const observedAttributes = ['disabled', 'aria-disabled', 'hidden', 'class', 'style'];
  let scope, scopedObserver, discoveryObserver, shadowObserver, activeRoot, upcartHost;
  let scheduled = false, probeTimer, probeRemaining = 0;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      sync();
    });
  }

  function discover() {
    if (discoveryObserver) return;
    discoveryObserver = new MutationObserver(records => {
      const host = document.getElementById('upCart');
      if (host !== upcartHost || (host?.shadowRoot && host.shadowRoot !== activeRoot)) {
        schedule();
        probeForShadowRoot();
        return;
      }
      if (activeRoot !== document) return;
      if (scope?.isConnected) return;
      if (scope) { schedule(); return; }
      if (records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches(footerSelector) || node.querySelector(footerSelector))))) schedule();
    });
    discoveryObserver.observe(document.body, {childList: true, subtree: true});
  }

  function bind(footer) {
    if (activeRoot !== document) return;
    const nextScope = footer.parentElement;
    if (scope === nextScope && scope?.isConnected) return;
    scopedObserver?.disconnect();
    scope = nextScope;
    if (!scope) return;
    scopedObserver = new MutationObserver(schedule);
    scopedObserver.observe(scope, {childList: true, subtree: true, attributes: true, attributeFilter: observedAttributes});
  }

  function copyStyles(root) {
    if (root === document) return;
    const source = document.querySelector('link[rel="stylesheet"][href*="sac-cart-recovery.css"]');
    if (!source?.href) return;
    let link = root.querySelector('link[data-sac-cart-recovery-styles]');
    if (!link) {
      link = document.createElement('link');
      link.id = 'sac-cart-recovery-shadow-styles';
      link.rel = 'stylesheet';
      link.dataset.sacCartRecoveryStyles = '';
      link.href = source.href;
      root.append(link);
    } else if (link.href !== source.href) {
      link.href = source.href;
    }
  }

  function selectRoot() {
    upcartHost = document.getElementById('upCart');
    const root = upcartHost?.shadowRoot || document;
    if (root !== activeRoot) {
      scopedObserver?.disconnect();
      shadowObserver?.disconnect();
      scope = undefined;
      activeRoot = root;
      if (root !== document) {
        shadowObserver = new MutationObserver(schedule);
        shadowObserver.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: observedAttributes});
      }
    }
    if (root !== document) {
      window.clearTimeout(probeTimer);
      probeTimer = undefined;
      probeRemaining = 0;
      copyStyles(root);
    }
    return root;
  }

  // attachShadow does not emit a document mutation. Check briefly during startup
  // and app lifecycle events, then stop; shadow mutations take over once found.
  function probeForShadowRoot() {
    if (document.getElementById('upCart')?.shadowRoot || probeTimer) return;
    probeRemaining = 60;
    const probe = () => {
      probeTimer = undefined;
      if (document.getElementById('upCart')?.shadowRoot) {
        schedule();
      } else if (--probeRemaining > 0) {
        probeTimer = window.setTimeout(probe, 250);
      }
    };
    probeTimer = window.setTimeout(probe, 250);
  }

  function refresh() {
    schedule();
    probeForShadowRoot();
  }

  function sync() {
    const footer = selectRoot().querySelector(footerSelector);
    if (!footer) {
      scopedObserver?.disconnect();
      scope = undefined;
      discover();
      return;
    }
    bind(footer);
    const checkoutWrapper = footer.querySelector('.upcart-checkout-button-container');
    const checkout = checkoutWrapper?.querySelector('.upcart-checkout-button');
    const cards = [...footer.querySelectorAll(cardSelector)];
    let card = cards.shift();
    cards.forEach(duplicate => duplicate.remove());
    const available = checkout && !checkout.disabled && checkout.getAttribute('aria-disabled') !== 'true' && !checkout.hidden && !checkoutWrapper.hidden && getComputedStyle(checkout).display !== 'none' && getComputedStyle(checkoutWrapper).display !== 'none';
    if (!available) {
      if (card && !card.hidden) card.hidden = true;
      return;
    }
    if (!card) {
      card = template.content.querySelector(cardSelector)?.cloneNode(true);
      if (!card) return;
    }
    if (card.previousElementSibling !== checkoutWrapper) checkoutWrapper.after(card);
    if (card.hidden) card.hidden = false;
  }

  window.addEventListener('aftersell-upcart:public-events:cart-loaded', refresh);
  window.addEventListener('aftersell-upcart:public-events:cart-updated', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('on:cart:add', refresh);
  document.addEventListener('on:line-item:change', refresh);
  discover();
  sync();
  probeForShadowRoot();
})();
